var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{attrs:{"href":_vm.href,"target":"_blank"}},[(_vm.text)?[_vm._v(_vm._s(_vm.text))]:[_vm._t("default")],_c('KIcon',{staticClass:"pop",attrs:{"icon":"openNewTab","disableColor":""}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }